"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderRow = void 0;
const react_1 = __importStar(require("react"));
const HeaderContext_1 = require("../contexts/HeaderContext");
const classnames_1 = __importDefault(require("classnames"));
const Cell_1 = require("./Cell");
exports.HeaderRow = react_1.default.memo(() => {
    const { columns, contentWidth, height, hasStickyRightColumn, activeColMin, activeColMax, } = react_1.useContext(HeaderContext_1.HeaderContext);
    return (react_1.default.createElement("div", { className: classnames_1.default('dsg-row', 'dsg-row-header'), style: {
            width: contentWidth ? contentWidth : '100%',
            height,
        } }, columns.map((column, i) => (react_1.default.createElement(Cell_1.Cell, { key: i, gutter: i === 0, stickyRight: hasStickyRightColumn && i === columns.length - 1, column: column, className: classnames_1.default('dsg-cell-header', activeColMin !== undefined &&
            activeColMax !== undefined &&
            activeColMin <= i - 1 &&
            activeColMax >= i - 1 &&
            'dsg-cell-header-active', column.headerClassName) },
        react_1.default.createElement("div", { className: "dsg-cell-header-container" }, column.title))))));
});
exports.HeaderRow.displayName = 'HeaderRow';
//# sourceMappingURL=HeaderRow.js.map